/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JobOutcomeNextWait = core.serialization.object({
    fade: core.serialization.boolean().optional(),
    confetti: core.serialization.boolean().optional(),
});
